// TODO: If you make edits to this file you must deal with these ESLint rules
/*eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

import styled from '@emotion/styled';

import { BREAKPOINTS, getColorTint, unit, unitTRBL } from '@zego/theme';

import H2 from '@zego/components/atoms/H2';
import H3 from '@zego/components/atoms/H3';
import View from '@zego/components/atoms/View';
import ContentContainer from '@zego/components/ContentContainer';
import HighImpactSection from '@zego/components/molecules/HighImpactSection';

interface image {
  imageUrl: string;
  imageAlt: string;
  imageRatio: number;
}

interface WhyChooseZegoCopy {
  title: string;
  description: React.ReactNode;
  image: image;
}

export interface WhyChooseZegoComponentProps {
  firstSection: WhyChooseZegoCopy;
  secondSection: WhyChooseZegoCopy;
  thirdSection: WhyChooseZegoCopy;
}

export default function WhyChooseZego({
  firstSection,
  secondSection,
  thirdSection,
}: WhyChooseZegoComponentProps): JSX.Element {
  return (
    <ContentContainer
      css={{
        padding: unitTRBL(8, 0, 0, 0),
      }}
    >
      <Title>Why choose zego?</Title>

      <StyledHighImpactSection imagePosition="left" {...firstSection.image}>
        <IndentedContainer>
          <HighImpactSectionTitle>{firstSection.title}</HighImpactSectionTitle>
          <Text>{firstSection.description}</Text>
        </IndentedContainer>
      </StyledHighImpactSection>

      <StyledHighImpactSection imagePosition="right" {...secondSection.image}>
        <Container>
          <HighImpactSectionTitle>
            {secondSection.title}
          </HighImpactSectionTitle>
          <Text>{secondSection.description}</Text>
        </Container>
      </StyledHighImpactSection>

      <StyledHighImpactSection imagePosition="left" {...thirdSection.image}>
        <IndentedContainer>
          <HighImpactSectionTitle>{thirdSection.title}</HighImpactSectionTitle>
          <Text>{thirdSection.description}</Text>
        </IndentedContainer>
      </StyledHighImpactSection>
    </ContentContainer>
  );
}

const Title = styled(H2)({
  textAlign: 'center',
  paddingBottom: unit(1),

  [BREAKPOINTS.normal]: {
    paddingBottom: unit(5),
  },
});

const HighImpactSectionTitle = styled(H3)({
  [BREAKPOINTS.small]: {
    lineHeight: '32px',
  },
});

const Text = styled.p({
  color: getColorTint('grey', 7),

  [BREAKPOINTS.smallOnly]: {
    marginTop: unit(1),
  },

  // On larger devices, this helps to make the lines of text wrap
  // exactly as the design does
  [BREAKPOINTS.normal]: {
    maxWidth: unit(45),
    fontSize: 22,
  },
});

const StyledHighImpactSection = styled(HighImpactSection)({
  paddingTop: unit(2),
  paddingBottom: unit(2),

  [BREAKPOINTS.large]: {
    paddingTop: unit(1),
  },
});

const Container = styled(View)({
  textAlign: 'center',

  [BREAKPOINTS.medium]: {
    textAlign: 'left',
    paddingLeft: unit(1),
  },
});

/** Indenting the text to align with the images below */
const IndentedContainer = styled(Container)({
  [BREAKPOINTS.medium]: {
    paddingLeft: unit(13),
  },
});
